<br><br><br>
<div class="page-title">
  <h1 class="title-text">SSE Index</h1>
</div>

<mat-card class="mat-mdc-elevation-specific mat-elevation-z8">
  <mat-card-content>
    <!-- Progress Tracker -->
    <mat-progress-bar mode="determinate" [value]="calculateProgress()"></mat-progress-bar>
    <div class="progress-status" style="display: flex; justify-content: space-between; margin-top: 16px;">
      <div style="text-align: center; width: 100%;">
        HR
        <br />
        @if (formData?.section1?.hrCompleted) {
          <span style="color: green;">Completed</span>
        }
        @if (!formData?.section1?.hrCompleted) {
          <span style="color: gray;">Pending</span>
        }
      </div>
      <div style="text-align: center; width: 100%;">
        Crew Manager
        <br />
        @if (formData?.section2?.ccCompleted) {
          <span style="color: green;">Completed</span>
        }
        @if (!formData?.section2?.ccCompleted) {
          <span style="color: gray;">Pending</span>
        }
      </div>
      <div style="text-align: center; width: 100%;">
        Safety Director
        <br />
        @if (formData?.section3?.smCompleted) {
          <span style="color: green;">Completed</span>
        }
        @if (!formData?.section3?.smCompleted) {
          <span style="color: gray;">Pending</span>
        }
      </div>
    </div>

    <div class="sections">
      <mat-accordion>
        <!-- Section 1: HR -->
        <mat-expansion-panel [expanded]="currentStep === 1">
          <mat-expansion-panel-header>
            <mat-panel-title>
              Short Service Employee Information (HR)
            </mat-panel-title>
          </mat-expansion-panel-header>
          @if (formData?.section1) {
            <div>
              <!-- Read-Only Mode -->
              @if (formData.section1.hrCompleted) {
                <p>SSE Employee Name: <span class="readonly">{{ formData.section1.hrName || 'N/A' }}</span></p>
                <p>Hire Date: <span class="readonly">{{ formData.section1.hrDate || 'N/A' }}</span></p>
                <p>Current Job Title: <span class="readonly">{{ formData.section1.hrTitle || 'N/A' }}</span></p>
                <p>Time in Present Position: <span class="readonly">{{ formData.section1.hrTime || 'N/A' }}</span></p>
                <p>Years of Verified Field Work Experience: <span class="readonly">{{ formData.section1.hrExp || 'N/A' }}</span></p>
                <p>Types of Field Work Experience: <span class="readonly">{{ formData.section1.hrDesc || 'N/A' }}</span></p>
                <p>SSE Employee Email: <span class="readonly">{{ formData.section1.hrEmail || 'N/A' }}</span></p>
                <p>Assigned Office: <span class="readonly">{{ formData.section1.hrOfficeEmail || 'N/A' }}</span></p>
              } @else {
                <mat-form-field appearance="fill" style="width: 100%;">
                  <mat-label>SSE Employee Name</mat-label>
                  <input matInput [(ngModel)]="formData.section1.hrName" />
                </mat-form-field>
                <mat-form-field appearance="fill" style="width: 100%;">
                  <mat-label>Hire Date</mat-label>
                  <input matInput [(ngModel)]="formData.section1.hrDate" type="date" />
                </mat-form-field>
                <mat-form-field appearance="fill" style="width: 100%;">
                  <mat-label>Current Job Title</mat-label>
                  <input matInput [(ngModel)]="formData.section1.hrTitle" />
                </mat-form-field>
                <mat-form-field appearance="fill" style="width: 100%;">
                  <mat-label>Time in Present Position</mat-label>
                  <input matInput [(ngModel)]="formData.section1.hrTime" />
                </mat-form-field>
                <mat-form-field appearance="fill" style="width: 100%;">
                  <mat-label>Years of Verified Field Work Experience</mat-label>
                  <input matInput [(ngModel)]="formData.section1.hrExp" />
                </mat-form-field>
                <mat-form-field appearance="fill" style="width: 100%;">
                  <mat-label>Types of Field Work Experience</mat-label>
                  <input matInput [(ngModel)]="formData.section1.hrDesc" />
                </mat-form-field>
                <mat-form-field appearance="fill" style="width: 100%;">
                  <mat-label>SSE Employee Email</mat-label>
                  <input matInput [(ngModel)]="formData.section1.hrEmail" />
                </mat-form-field>
                <mat-form-field appearance="fill" style="width: 100%;">
                  <mat-label>Select Office:</mat-label>
                  <mat-select [(ngModel)]="formData.section1.hrOfficeEmail">
                    <mat-option value="jsparks@landpoint.net">Ft. Worth</mat-option>
                    <mat-option value="trosen@landpoint.net">Houston</mat-option>
                    <mat-option value="travis.rosen34@gmail.com">Test</mat-option>
                  </mat-select>
                </mat-form-field>
                <button mat-raised-button color="primary" (click)="saveSection1()" [disabled]="loadingSection1">Complete Section</button>
                @if (loadingSection1) {
                  <div class="loading-spinner">
                    <mat-spinner diameter="30"></mat-spinner>
                  </div>
                }
              }
              <!-- Editable Mode -->
            </div>
          }
        </mat-expansion-panel>

        <!-- Section 2: Crew Manager -->
        <mat-expansion-panel [expanded]="currentStep === 2">
          <mat-expansion-panel-header>
            <mat-panel-title>
              SSE Mentor Information (Crew Manager)
            </mat-panel-title>
          </mat-expansion-panel-header>
          @if (formData?.section2) {
            <div>
              <!-- Read-Only Mode -->
              @if (formData.section2.ccCompleted) {
                <p>Mentor Employee Name: <span class="readonly">{{ formData.section2.ccName || 'N/A' }}</span></p>
                <p>Mentor Employee Hire Date: <span class="readonly">{{ formData.section2.ccDate || 'N/A' }}</span></p>
                <p>Current Job Title: <span class="readonly">{{ formData.section2.ccTitle || 'N/A' }}</span></p>
                <p>Time in Present Position: <span class="readonly">{{ formData.section2.ccTime || 'N/A' }}</span></p>
                <p>Years of Survey Experience: <span class="readonly">{{ formData.section2.ccExp || 'N/A' }}</span></p>
                <p>Types of Survey Experience: <span class="readonly">{{ formData.section2.ccDesc || 'N/A' }}</span></p>
                <p>Mentor Employee Email: <span class="readonly">{{ formData.section2.ccEmail || 'N/A' }}</span></p>
                <p>Crew Manager Signature: <span class="readonly">{{ formData.section2.ccNameSign || 'N/A' }}</span></p>
                <p>Date: <span class="readonly">{{ formData.section2.ccSignDate || 'N/A' }}</span></p>
              } @else {
                <mat-form-field appearance="fill" style="width: 100%;">
                  <mat-label>Mentor Employee Name</mat-label>
                  <input matInput [(ngModel)]="formData.section2.ccName" />
                </mat-form-field>
                <mat-form-field appearance="fill" style="width: 100%;">
                  <mat-label>Mentor Employee Hire Date</mat-label>
                  <input matInput [(ngModel)]="formData.section2.ccDate" type="date" />
                </mat-form-field>
                <mat-form-field appearance="fill" style="width: 100%;">
                  <mat-label>Current Job Title</mat-label>
                  <input matInput [(ngModel)]="formData.section2.ccTitle" />
                </mat-form-field>
                <mat-form-field appearance="fill" style="width: 100%;">
                  <mat-label>Time in Present Position</mat-label>
                  <input matInput [(ngModel)]="formData.section2.ccTime" />
                </mat-form-field>
                <mat-form-field appearance="fill" style="width: 100%;">
                  <mat-label>Years of Survey Experience</mat-label>
                  <input matInput [(ngModel)]="formData.section2.ccExp" />
                </mat-form-field>
                <mat-form-field appearance="fill" style="width: 100%;">
                  <mat-label>Types of Survey Experience</mat-label>
                  <input matInput [(ngModel)]="formData.section2.ccDesc" />
                </mat-form-field>
                <mat-form-field appearance="fill" style="width: 100%;">
                  <mat-label>Mentor Employee Email</mat-label>
                  <input matInput [(ngModel)]="formData.section2.ccEmail" />
                </mat-form-field>
                <mat-form-field appearance="fill" style="width: 100%;">
                  <mat-label>Crew Manager Signature</mat-label>
                  <input matInput [(ngModel)]="formData.section2.ccNameSign" />
                </mat-form-field>
                <mat-form-field appearance="fill" style="width: 100%;">
                  <mat-label>Date</mat-label>
                  <input matInput [(ngModel)]="formData.section2.ccSignDate" type="date" />
                </mat-form-field>
                <button mat-raised-button color="primary" (click)="saveSection2()" [disabled]="loadingSection2">Complete Section</button>
                @if (loadingSection2) {
                  <div class="loading-spinner">
                    <mat-spinner diameter="30"></mat-spinner>
                  </div>
                }
              }
              <!-- Editable Mode -->
            </div>
          }
        </mat-expansion-panel>

        <!-- Section 3: Safety Director -->
        <mat-expansion-panel [expanded]="currentStep === 3">
          <mat-expansion-panel-header>
            <mat-panel-title>
              Safety Director Sign-Off
            </mat-panel-title>
          </mat-expansion-panel-header>
          @if (formData?.section3) {
            <div>
              <!-- Read-Only Mode -->
              @if (formData.section3.smCompleted) {
                <p>SSE has received the required Safety Orientation: <span class="readonly">{{ formData.section3.smConfirm1 || 'N/A' }}</span></p>
                <p>SSE has received all required Safety Training *OSHA 10-hr: <span class="readonly">{{ formData.section3.smConfirm2 || 'N/A' }}</span></p>
                <p>SSE has received the required safety training: <span class="readonly">{{ formData.section3.smConfirm3 || 'N/A' }}</span></p>
              } @else {
                <mat-form-field appearance="fill" style="width: 100%;">
                  <mat-label>SSE has received the required Safety Orientation</mat-label>
                  <mat-select [(ngModel)]="formData.section3.smConfirm1">
                    <mat-option value="Yes">Yes</mat-option>
                    <mat-option value="No">No</mat-option>
                  </mat-select>
                </mat-form-field>
                <mat-form-field appearance="fill" style="width: 100%;">
                  <mat-label>SSE has received all required Safety Training *OSHA 10-hr</mat-label>
                  <mat-select [(ngModel)]="formData.section3.smConfirm2">
                    <mat-option value="Yes">Yes</mat-option>
                    <mat-option value="No">No</mat-option>
                  </mat-select>
                </mat-form-field>
                <mat-form-field appearance="fill" style="width: 100%;">
                  <mat-label>SSE has received the required safety training</mat-label>
                  <mat-select [(ngModel)]="formData.section3.smConfirm3">
                    <mat-option value="Yes">Yes</mat-option>
                    <mat-option value="No">No</mat-option>
                  </mat-select>
                </mat-form-field>
                <button mat-raised-button color="primary" (click)="saveSection3()" [disabled]="loadingSection3">Complete Section</button>
                @if (loadingSection3) {
                  <div class="loading-spinner">
                    <mat-spinner diameter="30"></mat-spinner>
                  </div>
                }
              }
              <!-- Editable Mode -->
            </div>
          }
        </mat-expansion-panel>
      </mat-accordion>
    </div>

  </mat-card-content>
  <br><br>

  @if (formData.section3?.smCompleted && sseListId) {
    <p class="dev-p">
      <a [routerLink]="['/sse-checklist', sseListId]" class="policy-link" routerLinkActive="active">View SSE Checklist</a>
    </p>
  }